import urlTool from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/favorites
 * @alias remove
 *
 * @description
 * Удаление товара из избранного
 *
 * @param {number} id - id товара, удаляемого из списка.
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.favorites.remove(123456)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(id) {
  let lang = urlTool.getKeyValue('lang') || '';
  let fields = { lang: lang };
  let path = '/front_api/favorites/' + parseInt(id) + '.json';

  return fetchJQueryAdapter(path,
    {
      method: 'DELETE',
      body: JSON.stringify(fields),
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
